import Cookies from "js-cookie";

const mutations = {
  mutationAuthCreate(state, payload) {
    state.userData = payload.user;
    state.userToken = payload.token;
    state.userTokenRefresh = payload.refresh;

    Cookies.set("u", state.userData, { expires: 7 });
    Cookies.set("t", state.userToken, { expires: 7 });
    Cookies.set("r", state.userTokenRefresh, { expires: 7 });

    this.$axios.setToken(state.userToken, "Bearer");
  },

  mutationAuthDataUpdate(state, payload) {
    state.userData = payload.user;
    Cookies.set("u", state.userData, { expires: 7 });
  },

  mutationAuthDestroy(state) {
    state.userData = null;
    state.userToken = null;
    state.userTokenRefresh = null;
    state.userOtpData = null;

    Cookies.remove("u");
    Cookies.remove("t");
    Cookies.remove("r");
  },

  mutationUserOtpData(state, payload) {
    state.userOtpData = payload;
  },

  mutationUserOrganizations(state, payload) {
    state.userOrganizations = payload;
  },

  mutationSetEmailActivation(state, data) {
    state.emailActivation = data;
  },

  mutationUserData(state, payload) {
    state.userData = payload;
  },
};

export default mutations;
